import { z } from 'zod';
import { skillCategorySchema } from './common.js';
import {
  strapiAwardBaseSchema,
  strapiCertificationBaseSchema,
  strapiExperienceBaseSchema,
  strapiProjectBaseSchema,
  strapiSkillBaseSchema,
} from './base.js';

export const strapiExperienceSchema = strapiExperienceBaseSchema.extend({
  categories: z.array(skillCategorySchema),
  skills: z.array(strapiSkillBaseSchema).nullish(),
  projects: z.array(strapiProjectBaseSchema).nullish(),
  certifications: z.array(strapiCertificationBaseSchema).nullish(),
  awards: z.array(strapiAwardBaseSchema).nullish(),
});

export type StrapiExperienceResponse = z.infer<typeof strapiExperienceSchema>;
